// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PricingHistoryQueryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Query-string input for GET /ai/credits/pricing/history.
 *
 * Optional:
 *   model (string|null) — filter to one AI model; null returns all models
 *   limit (int|null)    — max rows; server defaults/caps when absent or out of range
 */
import { registerContract } from './validate'

export interface AiCredits_PricingHistoryQueryInput {
model?: string
limit?: number
}

registerContract('AiCredits_PricingHistoryQueryInput', {
  model: { type: 'string',  required: false },
  limit: { type: 'number',  required: false },
})
